import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export default function WebinarQrCode({ webinarId, fallbackUrl }) {
  const [image, setImage] = useState(""), [value, setValue] = useState(fallbackUrl), [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get(`/webinars/${webinarId}/qr`);
        const QRCode = (await import("qrcode")).default;
        const target = data.value || fallbackUrl;
        const src = await QRCode.toDataURL(target, { errorCorrectionLevel: "M", margin: 2, width: 256, color: { dark: "#18181b", light: "#ffffff" } });
        if (active) { setValue(target); setImage(src); }
      } catch (_) { if (active) setError("QR indisponible : utilisez le lien ci-dessous."); }
    })();
    return () => { active = false; };
  }, [webinarId, fallbackUrl]);
  return <div className="flex flex-wrap items-center gap-3 rounded border border-zinc-800 bg-zinc-950/40 p-3">
    {image && <img src={image} width="128" height="128" alt={`QR code d’invitation pour ${value}`} className="h-32 w-32 rounded bg-white p-1" />}
    <div className="min-w-0 text-xs"><p className="font-medium text-zinc-200">Invitation par QR code</p><p className="mt-1 break-all text-zinc-400">{value}</p>{error && <p role="alert" className="mt-1 text-amber-400">{error}</p>}</div>
  </div>;
}
